import { CircularProgress, MenuItem, Select, Typography } from "@mui/material";
import { useCallback, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import InputContainer from "../../../components/InputContainer";
import { getPostsAction } from "../../../store/actions/poll";

const Questionnaire = ({ formik }) => {
  const dispatch = useDispatch();

  const posts = useSelector((s) => s.posts.data.byId);
  const allIds = useSelector((s) => s.posts.data.allIds);
  const loading = useSelector((s) => s.posts.loading);

  const fetchPosts = useCallback(
    ({ page, next }) => {
      getPostsAction({
        page,
        limit: 6,
        pageId: 183,
        next,
        type: "polls",
      })(dispatch);
    },
    [dispatch]
  );

  useEffect(() => {
    fetchPosts({ page: 1 });
  }, []);
  return (
    <>
      <InputContainer title={"Questionnaire"} sx={{ my: 1 }}>
        <Select
          fullWidth
          size="small"
          variant="standard"
          id="entityId"
          name="entityId"
          value={formik.values.entityId}
          MenuProps={{ PaperProps: { sx: { maxHeight: "300px" } } }}
          renderValue={
            formik.values.entityId !== ""
              ? undefined
              : () => (
                  <Typography variant="subtitle1" color="text.disabled">
                    choose Questionnaire
                  </Typography>
                )
          }
          displayEmpty
          onChange={(e) => {
            formik.handleChange(e);
          }}
          error={formik.touched.entityId && Boolean(formik.errors.entityId)}
          helperText={formik.touched.entityId && formik.errors.entityId}
          sx={{
            "& .MuiOutlinedInput-notchedOutline": {
              border: "2px solid #F6F6F6",
            },
            backgroundColor: "white",
          }}
        >
          {allIds?.length > 0 &&
            allIds?.map((postId, i) => {
              let post = posts[postId];
              return (
                <MenuItem key={i} value={post?.id}>
                  {post?.type?.poll?.questions?.[0]?.title}
                </MenuItem>
              );
            })}

          {loading && (
            <MenuItem>
              <CircularProgress size={20} sx={{ margin: "auto" }} />
            </MenuItem>
          )}
        </Select>
      </InputContainer>
    </>
  );
};

export default Questionnaire;
